<template>
    <div class="box">
        <div class="news">
            <div class="newsleft">
                <div class="leftpic">
                    <img
                            src="../../static/party _building.png"
                            style="height: 80px;"
                    />
                </div>
                <div class="leftpic1">
                    <img src="../../static/line.png" style="width: 100%; height: 100%"/>
                </div>
                <div class="leftTitle">党建工作</div>
                <div class="tabs">
                </div>
                <div class="jia" @click="jumpList">
                    <img src="../../static/jia.png" style="width: 100%; height: 100%"/>
                </div>
            </div>
            <div class="newsright">
                <div class="right_li" v-for="item in list" :key="item.id" @click="jumpDet(item)">
                    <div class="title">
                        <div class="text">{{ item.title }}</div>
                        <div class="time">{{ item.createTime }}</div>
                    </div>
                    <div class="concent" v-html="item.sketch">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "workOfParty",
    data() {
        return {
            queryParams: {
                pageSize: 10,
                pageNum: 1,
            },
            list: []
        };
    },
    created() {
        this.getList()
    },
    methods: {
      // 跳转文章列表
      jumpList() {
        this.$router.push({ path: "/newsCenter", query: {
            type: 'djgz',
            tabInd: 7
          } });
      },
      // 跳转文章详情
      jumpDet(v) {
        this.$router.push({ path: "/articleDet", query: {
            pageType: 'djgz',
            pageName: '',
            ...v
          } });
      },
        getList() {
            this.$api.getpartyBuilding(this.queryParams).then(res => {
                console.log(res, '-----党建工作')
                this.list = res.rows.length != 0 ? res.rows : []
                if (this.list.length != 0) {
                    this.list.forEach(item => {
                        item.createTime = item.createTime.split(' ')[0]
                    })
                }
            })
        },
    },
};
</script>

<style scoped lang="less">
.active {
  font-weight: 600;
  font-size: 1.25rem /* 20/16 */;
  color: #1e439b;
}

.box {
  //   display: inline-block;
  min-width: 93.75rem /* 1500/16 */;
  background-color: #f0f1f2;
  //padding: 150px;


  .news {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 100px 6.5rem;
    width: 93.75rem /* 1500/16 */;
    margin: 0 auto;
    min-width: 93.75rem /* 1500/16 */;

    .newsleft {
      margin-right: 6.25rem /* 100/16 */ /* 130/16 */;

      .leftpic {
        width: 17.6875rem /* 283/16 */;
        height: 5.9375rem /* 95/16 */;
        // margin-bottom: 30px;
      }

      .leftpic1 {
        width: 5.5625rem /* 89/16 */;
        margin-top: 1.9375rem /* 31/16 */;
        margin-bottom: 3.75rem /* 60/16 */;
      }

      .leftTitle {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 2.1875rem /* 35/16 */;
        color: #333333;
        line-height: 0rem /* 0/16 */;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .tabs {
        margin-top: 9.625rem /* 154/16 */;
        margin-bottom: 8.6875rem /* 139/16 */;
      }

      .line {
        width: 5rem /* 80/16 */;
        height: 0.125rem /* 2/16 */;
        background: #1e439b;
        border-radius: 0px 0px 0px 0px;
      }

      .tabs div {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 1.25rem /* 20/16 */;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 2.375rem /* 38/16 */;
        cursor: pointer;
      }

      .jia {
        width: 3.125rem /* 50/16 */;
        height: 3.125rem /* 50/16 */;
        cursor: pointer;
      }
    }

    .newsright {
      width: 100%;
      padding-top: 7.5rem /* 120/16 */;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;

      .right_li {
        cursor: pointer;
        padding: 1.875rem /* 30/16 */ 1.5625rem /* 25/16 */;
        background-color: #fff;
        width: 49%;
        margin-bottom: 1.25rem /* 20/16 */;

        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #333333;
          font-size: 1.125rem /* 18/16 */;
          font-weight: 550;
          margin-bottom: 1.0625rem /* 17/16 */;
            .text{
                width: 265px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .concent {
          color: #999999;
          font-size: 1rem /* 16/16 */;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
